import {
  AUTH_FETCH_FIREBASE_TOKEN_SUCCESS,
  AUTH_SET_KEYS,
  SET_ACCOUNT_CONFIG,
  SET_USER_CONFIG,
  SAFEWALK_UPDATE_STATE
} from '@actions/types'

const initialState = {
  accountId: null,
  accountHash: null,
  apiKey: null,
  hash: null,
  isAuthenticated: false,
  subscriberId: null,
  token: null,
  userConfig: null,
  accountConfig: null
}

const reducer = (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
  case AUTH_FETCH_FIREBASE_TOKEN_SUCCESS:
    return {
      ...state,
      token: payload.data.token
    }
  case SET_ACCOUNT_CONFIG:
    return {
      ...state,
      ...payload
    }
  case SET_USER_CONFIG:
    return {
      ...state,
      ...payload
    }
  case AUTH_SET_KEYS:
    return {
      ...state,
      ...payload
    }
  case SAFEWALK_UPDATE_STATE:
    return {
      ...state,
      ...payload
    }
  case '@@reactReduxFirebase/LOGIN':
    return {
      ...state,
      isAuthenticated: true
    }
  default:
    return state
  }
}

export default reducer
